/**
 * League of Managers - Initial Data
 */

import { Club, Player, Matchday, Fixture, StandingsRow } from '../types';

export const USER_CLUB_ID = 'club-user-01';

export const INITIAL_USER_CLUB: Club = {
  id: USER_CLUB_ID,
  name: 'Test FC',
  shortName: 'Test FC',
  code: 'TES',
  primaryColor: '#EE7500',
  secondaryColor: '#0046EB',
  shield: {
    templateId: 'MAD',
    primaryColor: '#EE7500',
    secondaryColor: '#0046EB',
    initials: 'BUR',
  },
  division: '10ª División',
  stadium: {
    name: 'Estadio Municipal de la Victoria',
    capacity: 15000,
    seasonTicketPrice: 260, // €/temporada
    seasonTicketHolders: 10000, // <= 70% del aforo (10.500 máx)
    ticketPrice: 35, // € por entrada ordinaria
    modules: {
      parkingLevel: 1,
      cafeteriaLevel: 1,
      merchandisingLevel: 1,
    },
  },
  staff: {
    goalkeeping: 1.0,
    fitness: 1.0,
    technical: 1.0,
    shooting: 1.0,
  },
  economy: {
    availableBalance: 100.0, // 100 M€ iniciales de tesorería
    reservedBalance: 0.0,
    subscriptionCredits: 1200, // 1.200 CR
    monthlyFeeCr: 100, // 100 CR de cuota mensual
    loans: [],
    ledger: [
      {
        id: 'led-init-01',
        timestamp: new Date().toISOString(),
        type: 'INGRESO',
        amount: 100.0,
        concept: 'Presupuesto inicial de constitución del Club',
        referenceId: 'INITIAL_CAPITAL',
        runningBalance: 100.0,
      },
    ],
  },
  recentForm: ['W', 'D', 'W', 'W', 'D'],
  isUser: true,
};

export const LEAGUE_CLUBS: Club[] = [
  INITIAL_USER_CLUB,
  {
    id: 'club-mad',
    name: 'Madrid Merengue FC',
    shortName: 'Madrid',
    code: 'MAD',
    primaryColor: '#e2e8f0',
    secondaryColor: '#3b82f6',
    division: 'Primera División',
    stadium: { name: 'Estadio La Castellana', capacity: 81000, seasonTicketPrice: 650, seasonTicketHolders: 55000, ticketPrice: 75, modules: { parkingLevel: 5, cafeteriaLevel: 5, merchandisingLevel: 5 } },
    staff: { goalkeeping: 4.5, fitness: 4.5, technical: 5.0, shooting: 5.0 },
    economy: { availableBalance: 180.0, reservedBalance: 0, subscriptionCredits: 2000, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['W', 'W', 'W', 'D', 'W'],
    isUser: false,
  },
  {
    id: 'club-bar',
    name: 'Barcelona Blaugrana',
    shortName: 'Barcelona',
    code: 'BAR',
    primaryColor: '#dc2626',
    secondaryColor: '#1d4ed8',
    division: 'Primera División',
    stadium: { name: 'Nou Temple', capacity: 95000, seasonTicketPrice: 600, seasonTicketHolders: 60000, ticketPrice: 70, modules: { parkingLevel: 4, cafeteriaLevel: 4, merchandisingLevel: 5 } },
    staff: { goalkeeping: 4.0, fitness: 4.0, technical: 4.5, shooting: 4.5 },
    economy: { availableBalance: 110.0, reservedBalance: 0, subscriptionCredits: 1500, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['W', 'W', 'D', 'W', 'L'],
    isUser: false,
  },
  {
    id: 'club-atm',
    name: 'Atlético Rojiblanco',
    shortName: 'Atlético',
    code: 'ATM',
    primaryColor: '#ef4444',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Metropolitano Sur', capacity: 68000, seasonTicketPrice: 450, seasonTicketHolders: 46000, ticketPrice: 55, modules: { parkingLevel: 4, cafeteriaLevel: 4, merchandisingLevel: 4 } },
    staff: { goalkeeping: 4.5, fitness: 4.5, technical: 4.0, shooting: 4.0 },
    economy: { availableBalance: 90.0, reservedBalance: 0, subscriptionCredits: 1400, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['W', 'D', 'W', 'D', 'W'],
    isUser: false,
  },
  {
    id: 'club-sev',
    name: 'Sevilla Nervión CF',
    shortName: 'Sevilla',
    code: 'SEV',
    primaryColor: '#b91c1c',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Ramón de Nervión', capacity: 43000, seasonTicketPrice: 380, seasonTicketHolders: 30000, ticketPrice: 45, modules: { parkingLevel: 3, cafeteriaLevel: 3, merchandisingLevel: 3 } },
    staff: { goalkeeping: 3.5, fitness: 3.5, technical: 3.5, shooting: 3.5 },
    economy: { availableBalance: 65.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['D', 'W', 'L', 'W', 'D'],
    isUser: false,
  },
  {
    id: 'club-bet',
    name: 'Real Betis Heliópolis',
    shortName: 'Betis',
    code: 'BET',
    primaryColor: '#16a34a',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Benito Villamarín', capacity: 55000, seasonTicketPrice: 390, seasonTicketHolders: 38000, ticketPrice: 45, modules: { parkingLevel: 3, cafeteriaLevel: 3, merchandisingLevel: 3 } },
    staff: { goalkeeping: 3.5, fitness: 3.5, technical: 4.0, shooting: 3.5 },
    economy: { availableBalance: 60.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['W', 'L', 'W', 'D', 'W'],
    isUser: false,
  },
  {
    id: 'club-rso',
    name: 'Real Donostia',
    shortName: 'R. Sociedad',
    code: 'RSO',
    primaryColor: '#2563eb',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Reale Arena Norte', capacity: 40000, seasonTicketPrice: 360, seasonTicketHolders: 28000, ticketPrice: 42, modules: { parkingLevel: 3, cafeteriaLevel: 3, merchandisingLevel: 3 } },
    staff: { goalkeeping: 4.0, fitness: 3.5, technical: 4.0, shooting: 3.5 },
    economy: { availableBalance: 70.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['W', 'W', 'D', 'L', 'W'],
    isUser: false,
  },
  {
    id: 'club-ath',
    name: 'Athletic Leones',
    shortName: 'Athletic',
    code: 'ATH',
    primaryColor: '#dc2626',
    secondaryColor: '#000000',
    division: 'Primera División',
    stadium: { name: 'San Mamés Catedral', capacity: 53000, seasonTicketPrice: 420, seasonTicketHolders: 37000, ticketPrice: 50, modules: { parkingLevel: 3, cafeteriaLevel: 4, merchandisingLevel: 4 } },
    staff: { goalkeeping: 4.0, fitness: 4.5, technical: 3.5, shooting: 3.5 },
    economy: { availableBalance: 85.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['D', 'W', 'W', 'D', 'L'],
    isUser: false,
  },
  {
    id: 'club-vil',
    name: 'Villarreal Groguet',
    shortName: 'Villarreal',
    code: 'VIL',
    primaryColor: '#eab308',
    secondaryColor: '#0284c7',
    division: 'Primera División',
    stadium: { name: 'Estadio de la Cerámica', capacity: 23500, seasonTicketPrice: 320, seasonTicketHolders: 16000, ticketPrice: 40, modules: { parkingLevel: 3, cafeteriaLevel: 3, merchandisingLevel: 3 } },
    staff: { goalkeeping: 3.5, fitness: 3.5, technical: 4.0, shooting: 4.0 },
    economy: { availableBalance: 55.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['L', 'W', 'D', 'W', 'W'],
    isUser: false,
  },
  {
    id: 'club-val',
    name: 'Valencia Che',
    shortName: 'Valencia',
    code: 'VAL',
    primaryColor: '#ffffff',
    secondaryColor: '#f97316',
    division: 'Primera División',
    stadium: { name: 'Mestalla Histórico', capacity: 49000, seasonTicketPrice: 350, seasonTicketHolders: 34000, ticketPrice: 40, modules: { parkingLevel: 2, cafeteriaLevel: 3, merchandisingLevel: 3 } },
    staff: { goalkeeping: 3.5, fitness: 3.0, technical: 3.5, shooting: 3.0 },
    economy: { availableBalance: 45.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['L', 'D', 'L', 'W', 'D'],
    isUser: false,
  },
  {
    id: 'club-gir',
    name: 'Girona Montilivi',
    shortName: 'Girona',
    code: 'GIR',
    primaryColor: '#ef4444',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Montilivi', capacity: 14600, seasonTicketPrice: 300, seasonTicketHolders: 10000, ticketPrice: 38, modules: { parkingLevel: 2, cafeteriaLevel: 2, merchandisingLevel: 2 } },
    staff: { goalkeeping: 3.0, fitness: 3.5, technical: 4.0, shooting: 3.5 },
    economy: { availableBalance: 40.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['W', 'L', 'W', 'W', 'D'],
    isUser: false,
  },
  {
    id: 'club-cel',
    name: 'Celta Olívico',
    shortName: 'Celta',
    code: 'CEL',
    primaryColor: '#38bdf8',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Balaídos', capacity: 25000, seasonTicketPrice: 290, seasonTicketHolders: 17000, ticketPrice: 35, modules: { parkingLevel: 2, cafeteriaLevel: 2, merchandisingLevel: 2 } },
    staff: { goalkeeping: 3.0, fitness: 3.0, technical: 3.5, shooting: 3.5 },
    economy: { availableBalance: 35.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['D', 'L', 'W', 'D', 'L'],
    isUser: false,
  },
  {
    id: 'club-osa',
    name: 'Osasuna Rojillo',
    shortName: 'Osasuna',
    code: 'OSA',
    primaryColor: '#b91c1c',
    secondaryColor: '#1e3a8a',
    division: 'Primera División',
    stadium: { name: 'El Sadar', capacity: 23500, seasonTicketPrice: 310, seasonTicketHolders: 16000, ticketPrice: 36, modules: { parkingLevel: 2, cafeteriaLevel: 2, merchandisingLevel: 2 } },
    staff: { goalkeeping: 3.0, fitness: 4.0, technical: 3.0, shooting: 3.0 },
    economy: { availableBalance: 38.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['W', 'D', 'L', 'L', 'W'],
    isUser: false,
  },
  {
    id: 'club-mll',
    name: 'Mallorca Bermellón',
    shortName: 'Mallorca',
    code: 'MLL',
    primaryColor: '#dc2626',
    secondaryColor: '#000000',
    division: 'Primera División',
    stadium: { name: 'Son Moix', capacity: 26000, seasonTicketPrice: 280, seasonTicketHolders: 17000, ticketPrice: 35, modules: { parkingLevel: 2, cafeteriaLevel: 2, merchandisingLevel: 2 } },
    staff: { goalkeeping: 3.0, fitness: 3.5, technical: 3.0, shooting: 3.0 },
    economy: { availableBalance: 30.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['D', 'W', 'D', 'L', 'D'],
    isUser: false,
  },
  {
    id: 'club-ray',
    name: 'Rayo Franjirrojo',
    shortName: 'Rayo',
    code: 'RAY',
    primaryColor: '#ffffff',
    secondaryColor: '#ef4444',
    division: 'Primera División',
    stadium: { name: 'Vallecas', capacity: 14700, seasonTicketPrice: 260, seasonTicketHolders: 10200, ticketPrice: 32, modules: { parkingLevel: 1, cafeteriaLevel: 2, merchandisingLevel: 1 } },
    staff: { goalkeeping: 2.5, fitness: 3.0, technical: 3.0, shooting: 3.0 },
    economy: { availableBalance: 28.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['L', 'D', 'W', 'L', 'D'],
    isUser: false,
  },
  {
    id: 'club-get',
    name: 'Getafe Azulón',
    shortName: 'Getafe',
    code: 'GET',
    primaryColor: '#1d4ed8',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Coliseum', capacity: 16500, seasonTicketPrice: 270, seasonTicketHolders: 11000, ticketPrice: 32, modules: { parkingLevel: 2, cafeteriaLevel: 2, merchandisingLevel: 1 } },
    staff: { goalkeeping: 3.0, fitness: 3.5, technical: 2.5, shooting: 2.5 },
    economy: { availableBalance: 32.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['D', 'L', 'D', 'D', 'L'],
    isUser: false,
  },
  {
    id: 'club-ala',
    name: 'Deportivo Babazorro',
    shortName: 'Alavés',
    code: 'ALA',
    primaryColor: '#2563eb',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Mendizorroza', capacity: 19800, seasonTicketPrice: 260, seasonTicketHolders: 13000, ticketPrice: 30, modules: { parkingLevel: 2, cafeteriaLevel: 2, merchandisingLevel: 1 } },
    staff: { goalkeeping: 2.5, fitness: 3.0, technical: 2.5, shooting: 2.5 },
    economy: { availableBalance: 25.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['L', 'W', 'L', 'D', 'L'],
    isUser: false,
  },
  {
    id: 'club-lpa',
    name: 'Unión Insular',
    shortName: 'Las Palmas',
    code: 'LPA',
    primaryColor: '#eab308',
    secondaryColor: '#2563eb',
    division: 'Primera División',
    stadium: { name: 'Gran Canaria Arena', capacity: 32400, seasonTicketPrice: 270, seasonTicketHolders: 22000, ticketPrice: 30, modules: { parkingLevel: 2, cafeteriaLevel: 2, merchandisingLevel: 2 } },
    staff: { goalkeeping: 2.5, fitness: 2.5, technical: 3.5, shooting: 2.5 },
    economy: { availableBalance: 27.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['L', 'L', 'D', 'W', 'L'],
    isUser: false,
  },
  {
    id: 'club-leg',
    name: 'Leganés Pepinero',
    shortName: 'Leganés',
    code: 'LEG',
    primaryColor: '#1e40af',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'Butarque', capacity: 12450, seasonTicketPrice: 250, seasonTicketHolders: 8500, ticketPrice: 30, modules: { parkingLevel: 1, cafeteriaLevel: 1, merchandisingLevel: 1 } },
    staff: { goalkeeping: 2.5, fitness: 2.5, technical: 2.5, shooting: 2.5 },
    economy: { availableBalance: 22.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['L', 'D', 'L', 'L', 'W'],
    isUser: false,
  },
  {
    id: 'club-val2',
    name: 'Real Pucela',
    shortName: 'Valladolid',
    code: 'VLL',
    primaryColor: '#7e22ce',
    secondaryColor: '#ffffff',
    division: 'Primera División',
    stadium: { name: 'José Zorrilla', capacity: 27600, seasonTicketPrice: 260, seasonTicketHolders: 18000, ticketPrice: 28, modules: { parkingLevel: 2, cafeteriaLevel: 2, merchandisingLevel: 1 } },
    staff: { goalkeeping: 2.5, fitness: 2.5, technical: 2.5, shooting: 2.0 },
    economy: { availableBalance: 20.0, reservedBalance: 0, subscriptionCredits: 1200, monthlyFeeCr: 100, loans: [], ledger: [] },
    recentForm: ['L', 'L', 'L', 'D', 'L'],
    isUser: false,
  },
];

// 11 jugadores amateurs iniciales al alta para el club del usuario
export const INITIAL_USER_SQUAD: Player[] = [
  {
    id: 'p-amateur-01',
    name: 'Diego Valdés (Amateur)',
    shortName: 'Valdés',
    position: 'POR',
    overall: 60,
    age: 21,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.2, durationYears: 2, releaseClause: 5.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.5,
  },
  {
    id: 'p-amateur-02',
    name: 'Marcos Rivas (Amateur)',
    shortName: 'Rivas',
    position: 'DEF',
    overall: 59,
    age: 22,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.2, durationYears: 2, releaseClause: 4.5, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.0,
  },
  {
    id: 'p-amateur-03',
    name: 'Lucas Arana (Amateur)',
    shortName: 'Arana',
    position: 'DEF',
    overall: 61,
    age: 24,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.25, durationYears: 2, releaseClause: 5.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.2,
  },
  {
    id: 'p-amateur-04',
    name: 'Samuel Otegui (Amateur)',
    shortName: 'Otegui',
    position: 'DEF',
    overall: 58,
    age: 20,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.18, durationYears: 2, releaseClause: 4.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.0,
  },
  {
    id: 'p-amateur-05',
    name: 'Jordi Solsona (Amateur)',
    shortName: 'Solsona',
    position: 'DEF',
    overall: 60,
    age: 23,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.22, durationYears: 2, releaseClause: 4.8, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.1,
  },
  {
    id: 'p-amateur-06',
    name: 'Carlos Benítez (Amateur)',
    shortName: 'Benítez',
    position: 'MED',
    overall: 62,
    age: 23,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.25, durationYears: 3, releaseClause: 6.0, acquisitionCost: 0, startSeason: 1, endSeason: 4 },
    listedForTransfer: false,
    formScore: 3.8,
  },
  {
    id: 'p-amateur-07',
    name: 'Iván Sanchís (Amateur)',
    shortName: 'Sanchís',
    position: 'MED',
    overall: 59,
    age: 22,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.2, durationYears: 2, releaseClause: 4.5, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.2,
  },
  {
    id: 'p-amateur-08',
    name: 'Raúl Torrente (Amateur)',
    shortName: 'Torrente',
    position: 'MED',
    overall: 61,
    age: 25,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.24, durationYears: 2, releaseClause: 5.5, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.4,
  },
  {
    id: 'p-amateur-09',
    name: 'Rubén Montero (Amateur)',
    shortName: 'Montero',
    position: 'DEL',
    overall: 62,
    age: 21,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.28, durationYears: 3, releaseClause: 7.0, acquisitionCost: 0, startSeason: 1, endSeason: 4 },
    listedForTransfer: false,
    formScore: 3.5,
  },
  {
    id: 'p-amateur-10',
    name: 'Álvaro Carrizo (Amateur)',
    shortName: 'Carrizo',
    position: 'DEL',
    overall: 63,
    age: 24,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.3, durationYears: 2, releaseClause: 7.5, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.7,
  },
  {
    id: 'p-amateur-11',
    name: 'Pau Castells (Amateur)',
    shortName: 'Castells',
    position: 'DEL',
    overall: 60,
    age: 20,
    nationality: 'España',
    isAmateur: true,
    clubId: USER_CLUB_ID,
    contract: { salary: 0.22, durationYears: 2, releaseClause: 5.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.3,
  },
];

// Catálogo de 12 futbolistas libres diarios disponibles en el mercado
export const INITIAL_FREE_AGENTS: Player[] = [
  {
    id: 'fa-01',
    name: 'Álvaro Valles',
    shortName: 'A. Valles',
    position: 'POR',
    overall: 80,
    age: 27,
    nationality: 'España',
    isAmateur: false,
    clubId: null,
    contract: { salary: 2.2, durationYears: 3, releaseClause: 25.0, acquisitionCost: 0, startSeason: 1, endSeason: 4 },
    listedForTransfer: false,
    formScore: 3.8,
  },
  {
    id: 'fa-02',
    name: 'Sergio Ramos',
    shortName: 'S. Ramos',
    position: 'DEF',
    overall: 82,
    age: 38,
    nationality: 'España',
    isAmateur: false,
    clubId: null,
    contract: { salary: 3.5, durationYears: 1, releaseClause: 20.0, acquisitionCost: 0, startSeason: 1, endSeason: 2 },
    listedForTransfer: false,
    formScore: 4.0,
  },
  {
    id: 'fa-03',
    name: 'Mats Hummels',
    shortName: 'M. Hummels',
    position: 'DEF',
    overall: 83,
    age: 35,
    nationality: 'Alemania',
    isAmateur: false,
    clubId: null,
    contract: { salary: 3.8, durationYears: 2, releaseClause: 22.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 4.1,
  },
  {
    id: 'fa-04',
    name: 'Mario Hermoso',
    shortName: 'M. Hermoso',
    position: 'DEF',
    overall: 81,
    age: 29,
    nationality: 'España',
    isAmateur: false,
    clubId: null,
    contract: { salary: 2.8, durationYears: 3, releaseClause: 30.0, acquisitionCost: 0, startSeason: 1, endSeason: 4 },
    listedForTransfer: false,
    formScore: 3.9,
  },
  {
    id: 'fa-05',
    name: 'Adrien Rabiot',
    shortName: 'A. Rabiot',
    position: 'MED',
    overall: 84,
    age: 29,
    nationality: 'Francia',
    isAmateur: false,
    clubId: null,
    contract: { salary: 4.8, durationYears: 3, releaseClause: 45.0, acquisitionCost: 0, startSeason: 1, endSeason: 4 },
    listedForTransfer: false,
    formScore: 4.2,
  },
  {
    id: 'fa-06',
    name: 'André Gomes',
    shortName: 'A. Gomes',
    position: 'MED',
    overall: 78,
    age: 31,
    nationality: 'Portugal',
    isAmateur: false,
    clubId: null,
    contract: { salary: 1.8, durationYears: 2, releaseClause: 18.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.5,
  },
  {
    id: 'fa-07',
    name: 'Guido Rodríguez',
    shortName: 'G. Rodríguez',
    position: 'MED',
    overall: 81,
    age: 30,
    nationality: 'Argentina',
    isAmateur: false,
    clubId: null,
    contract: { salary: 3.0, durationYears: 3, releaseClause: 35.0, acquisitionCost: 0, startSeason: 1, endSeason: 4 },
    listedForTransfer: false,
    formScore: 3.9,
  },
  {
    id: 'fa-08',
    name: 'Iker Muniain',
    shortName: 'I. Muniain',
    position: 'MED',
    overall: 79,
    age: 31,
    nationality: 'España',
    isAmateur: false,
    clubId: null,
    contract: { salary: 2.4, durationYears: 2, releaseClause: 22.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.7,
  },
  {
    id: 'fa-09',
    name: 'Memphis Depay',
    shortName: 'M. Depay',
    position: 'DEL',
    overall: 82,
    age: 30,
    nationality: 'Países Bajos',
    isAmateur: false,
    clubId: null,
    contract: { salary: 4.0, durationYears: 2, releaseClause: 38.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 4.0,
  },
  {
    id: 'fa-10',
    name: 'Wissam Ben Yedder',
    shortName: 'W. Ben Yedder',
    position: 'DEL',
    overall: 81,
    age: 34,
    nationality: 'Francia',
    isAmateur: false,
    clubId: null,
    contract: { salary: 3.2, durationYears: 2, releaseClause: 25.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.8,
  },
  {
    id: 'fa-11',
    name: 'Anthony Martial',
    shortName: 'A. Martial',
    position: 'DEL',
    overall: 79,
    age: 28,
    nationality: 'Francia',
    isAmateur: false,
    clubId: null,
    contract: { salary: 3.0, durationYears: 2, releaseClause: 28.0, acquisitionCost: 0, startSeason: 1, endSeason: 3 },
    listedForTransfer: false,
    formScore: 3.6,
  },
  {
    id: 'fa-12',
    name: 'Eric Maxim Choupo-Moting',
    shortName: 'Choupo-Moting',
    position: 'DEL',
    overall: 77,
    age: 35,
    nationality: 'Camerún',
    isAmateur: false,
    clubId: null,
    contract: { salary: 1.6, durationYears: 1, releaseClause: 12.0, acquisitionCost: 0, startSeason: 1, endSeason: 2 },
    listedForTransfer: false,
    formScore: 3.4,
  },
];

// Jugadores destacados de otros clubes para cláusulas de rescisión y transferencias entre clubes
export const OPPONENT_STARS: Player[] = [
  {
    id: 'p-mad-01',
    name: 'Kylian Mbappé',
    shortName: 'Mbappé',
    position: 'DEL',
    overall: 91,
    age: 25,
    nationality: 'Francia',
    isAmateur: false,
    clubId: 'club-mad',
    contract: { salary: 18.0, durationYears: 5, releaseClause: 120.0, acquisitionCost: 0, startSeason: 1, endSeason: 6 },
    listedForTransfer: false,
    formScore: 4.8,
  },
  {
    id: 'p-mad-02',
    name: 'Jude Bellingham',
    shortName: 'Bellingham',
    position: 'MED',
    overall: 90,
    age: 21,
    nationality: 'Inglaterra',
    isAmateur: false,
    clubId: 'club-mad',
    contract: { salary: 14.0, durationYears: 5, releaseClause: 110.0, acquisitionCost: 103, startSeason: 1, endSeason: 6 },
    listedForTransfer: false,
    formScore: 4.7,
  },
  {
    id: 'p-bar-01',
    name: 'Lamine Yamal',
    shortName: 'L. Yamal',
    position: 'DEL',
    overall: 86,
    age: 17,
    nationality: 'España',
    isAmateur: false,
    clubId: 'club-bar',
    contract: { salary: 5.0, durationYears: 4, releaseClause: 80.0, acquisitionCost: 0, startSeason: 1, endSeason: 5 },
    listedForTransfer: false,
    formScore: 4.6,
  },
  {
    id: 'p-bar-02',
    name: 'Pedri González',
    shortName: 'Pedri',
    position: 'MED',
    overall: 87,
    age: 21,
    nationality: 'España',
    isAmateur: false,
    clubId: 'club-bar',
    contract: { salary: 8.5, durationYears: 4, releaseClause: 85.0, acquisitionCost: 20, startSeason: 1, endSeason: 5 },
    listedForTransfer: false,
    formScore: 4.5,
  },
  {
    id: 'p-atm-01',
    name: 'Antoine Griezmann',
    shortName: 'Griezmann',
    position: 'DEL',
    overall: 88,
    age: 33,
    nationality: 'Francia',
    isAmateur: false,
    clubId: 'club-atm',
    contract: { salary: 10.0, durationYears: 2, releaseClause: 40.0, acquisitionCost: 22, startSeason: 1, endSeason: 3 },
    listedForTransfer: true,
    askingPrice: 35.0,
    formScore: 4.4,
  },
  {
    id: 'p-atm-02',
    name: 'Jan Oblak',
    shortName: 'Oblak',
    position: 'POR',
    overall: 88,
    age: 31,
    nationality: 'Eslovenia',
    isAmateur: false,
    clubId: 'club-atm',
    contract: { salary: 9.0, durationYears: 3, releaseClause: 45.0, acquisitionCost: 16, startSeason: 1, endSeason: 4 },
    listedForTransfer: false,
    formScore: 4.3,
  },
  {
    id: 'p-ath-01',
    name: 'Nico Williams',
    shortName: 'N. Williams',
    position: 'DEL',
    overall: 85,
    age: 22,
    nationality: 'España',
    isAmateur: false,
    clubId: 'club-ath',
    contract: { salary: 6.0, durationYears: 3, releaseClause: 58.0, acquisitionCost: 0, startSeason: 1, endSeason: 4 },
    listedForTransfer: true,
    askingPrice: 55.0,
    formScore: 4.4,
  },
  {
    id: 'p-rso-01',
    name: 'Martín Zubimendi',
    shortName: 'Zubimendi',
    position: 'MED',
    overall: 84,
    age: 25,
    nationality: 'España',
    isAmateur: false,
    clubId: 'club-rso',
    contract: { salary: 4.5, durationYears: 3, releaseClause: 60.0, acquisitionCost: 0, startSeason: 1, endSeason: 4 },
    listedForTransfer: false,
    formScore: 4.2,
  },
  {
    id: 'p-sev-01',
    name: 'Loïc Badé',
    shortName: 'Badé',
    position: 'DEF',
    overall: 81,
    age: 24,
    nationality: 'Francia',
    isAmateur: false,
    clubId: 'club-sev',
    contract: { salary: 2.8, durationYears: 3, releaseClause: 30.0, acquisitionCost: 12, startSeason: 1, endSeason: 4 },
    listedForTransfer: true,
    askingPrice: 26.0,
    formScore: 3.9,
  },
  {
    id: 'p-vil-01',
    name: 'Álex Baena',
    shortName: 'A. Baena',
    position: 'MED',
    overall: 82,
    age: 23,
    nationality: 'España',
    isAmateur: false,
    clubId: 'club-vil',
    contract: { salary: 3.5, durationYears: 4, releaseClause: 40.0, acquisitionCost: 0, startSeason: 1, endSeason: 5 },
    listedForTransfer: true,
    askingPrice: 38.0,
    formScore: 4.1,
  },
];

// Helper to generate full 38-matchday round-robin schedule for the 20 clubs
export function generateLeagueMatchdays(clubs: Club[]): Matchday[] {
  const n = clubs.length;
  const matchdays: Matchday[] = [];
  const teamIds = clubs.map((c) => c.id);

  // Round Robin scheduling algorithm (Berger tables)
  // 19 rounds first leg, 19 rounds reverse leg = 38 total
  const teams = [...teamIds];
  const rounds = n - 1; // 19 rounds
  const matchesPerRound = n / 2; // 10 matches per round

  const firstLegRounds: { home: string; away: string }[][] = [];

  for (let r = 0; r < rounds; r++) {
    const roundFixtures: { home: string; away: string }[] = [];
    for (let m = 0; m < matchesPerRound; m++) {
      const home = teams[m];
      const away = teams[n - 1 - m];
      // Alternate home/away for fair distribution
      if ((r + m) % 2 === 0) {
        roundFixtures.push({ home, away });
      } else {
        roundFixtures.push({ home: away, away: home });
      }
    }
    firstLegRounds.push(roundFixtures);
    // Rotate array keeping index 0 fixed
    teams.splice(1, 0, teams.pop()!);
  }

  // Create 38 Matchdays
  for (let d = 1; d <= 38; d++) {
    const isFirstLeg = d <= 19;
    const roundIdx = isFirstLeg ? d - 1 : d - 20;
    const legFixtures = firstLegRounds[roundIdx];

    const fixtures: Fixture[] = legFixtures.map((f, i) => {
      const homeClubId = isFirstLeg ? f.home : f.away;
      const awayClubId = isFirstLeg ? f.away : f.home;
      return {
        id: `fix-j${d}-${i + 1}`,
        matchdayNumber: d,
        homeClubId,
        awayClubId,
        played: false,
      };
    });

    matchdays.push({
      number: d,
      season: 1,
      status: d === 1 ? 'OPEN' : 'PLANNED',
      date: `Jornada ${d} · Temporada 2026/27`,
      fixtures,
    });
  }

  return matchdays;
}

export function generateInitialStandings(clubs: Club[]): StandingsRow[] {
  return clubs.map((club) => ({
    clubId: club.id,
    clubName: club.name,
    clubCode: club.code,
    played: 0,
    won: 0,
    drawn: 0,
    lost: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalDifference: 0,
    points: 0,
    recentForm: [],
  }));
}
